import React from "react";
import { route, routes } from "~/helpers/routeHelper";

const Dashboard = React.lazy(() => import("~/pages/Dashboard"));
const ProfileSetupTerms = React.lazy(() => import("~/pages/Profile/Setup/Terms"));
const ProfileSetupBilling = React.lazy(() => import("~/pages/Profile/Setup/Billing"));
const ProfileSetupShipping = React.lazy(() => import("~/pages/Profile/Setup/Shipping"));
const ProfileSetupContact = React.lazy(() => import("~/pages/Profile/Setup/Contact"));
const ProfileSetupCredentials = React.lazy(() => import("~/pages/Profile/Setup/Credentials"));
const ProfileSetupExperience = React.lazy(() => import("~/pages/Profile/Setup/Experience"));
const ProfileSetupArea = React.lazy(() => import("~/pages/Profile/Setup/Area"));
const ProfileViewIndex = React.lazy(() => import("~/pages/Profile/View/index"));
const NotaryBidList = React.lazy(() => import("~/pages/NotaryBid/List"));
const NotaryBidView = React.lazy(() => import("~/pages/NotaryBid/View"));
const OrderList = React.lazy(() => import("~/pages/Order/List"));
const OrderView = React.lazy(() => import("~/pages/Order/View"));
const OrderViewMessages = React.lazy(() => import("~/pages/Order/View/Messages"));
const OrderViewFlow = React.lazy(() => import("~/pages/Order/View/Flow"));
const OrderViewChannel = React.lazy(() => import("~/pages/Order/View/Channel"));
const AccountingList = React.lazy(() => import("~/pages/Accounting/List"));
const NotificationList = React.lazy(() => import("~/pages/Notification/List"));
const NotificationView = React.lazy(() => import("~/pages/Notification/View"));
const MessageList = React.lazy(() => import("~/pages/Message/List"));
const Documents = React.lazy(() => import("~/pages/Documents"));
const TermsView = React.lazy(() => import("~/pages/Terms/View"));
const MeetScheduler = React.lazy(() => import("~/pages/Meeting/Scheduler"));
const HelpList = React.lazy(() => import("~/pages/Help/List"));
const GeneralInformation = React.lazy(() => import("~/components/Shared/GlbaAssessment/New/GeneralInformation"));
const SecurityPractices = React.lazy(() => import("~/components/Shared/GlbaAssessment/New/SecurityPractices"));
const AccessRetentionPolicies = React.lazy(() => import("~/components/Shared/GlbaAssessment/New/AccessRetentionPolicies"));
const NotaryMobileApp = React.lazy(() => import("~/pages/MarketingPages/NotaryMobileApp"));

export interface RouteConfig {
  path: string;
  component: React.ComponentType<any>;
  props?: any;
  layout?: React.ComponentType<any>;
  isSetupRoute?: boolean;
  isGlbaRoute?: boolean;
  isStrict?: boolean;
}

const publicRoutes: RouteConfig[] = [

];

const protectedRoutes: RouteConfig[] = [
  { path: route(routes.setup_profile_terms), component: ProfileSetupTerms, isSetupRoute: true },
  { path: route(routes.setup_profile_billing), component: ProfileSetupBilling, isSetupRoute: true },
  { path: route(routes.setup_profile_shipping), component: ProfileSetupShipping, isSetupRoute: true },
  { path: route(routes.setup_profile_contact), component: ProfileSetupContact, isSetupRoute: true },
  { path: route(routes.setup_profile_credentials), component: ProfileSetupCredentials, isSetupRoute: true },
  { path: route(routes.setup_profile_experience), component: ProfileSetupExperience, isSetupRoute: true },
  { path: route(routes.setup_profile_area), component: ProfileSetupArea, isSetupRoute: true },
  { path: route(routes.view_terms), component: TermsView, isSetupRoute: true },

  { path: route(routes.home), component: Dashboard },

  { path: route(routes.view_profile), component: ProfileViewIndex },

  { path: route(routes.list_notary_bids), component: NotaryBidList },
  { path: route(routes.view_notary_bid), component: NotaryBidView },

  { path: route(routes.list_orders), component: OrderList },
  { path: route(routes.view_order), component: OrderView },
  { path: route(routes.view_order_messages), component: OrderViewMessages },
  { path: route(routes.view_order_channel), component: OrderViewChannel },
  { path: route(routes.view_order_flow), component: OrderViewFlow },

  { path: route(routes.list_notary_accounting), component: AccountingList },

  { path: route(routes.list_notifications), component: NotificationList },
  { path: route(routes.view_notification), component: NotificationView },

  { path: route(routes.list_messages), component: MessageList },

  { path: route(routes.view_documents), component: Documents },

  { path: route(routes.meet_scheduler), component: MeetScheduler },

  { path: route(routes.list_help), component: HelpList },

  { path: route(routes.glba_general_information), component: GeneralInformation, isGlbaRoute: true },
  { path: route(routes.glba_security_practices), component: SecurityPractices, isGlbaRoute: true },
  { path: route(routes.glba_access_retention_policies), component: AccessRetentionPolicies, isGlbaRoute: true },

  { path: route(routes.view_notary_mobile_app), component: NotaryMobileApp },
];

export { publicRoutes, protectedRoutes }
